import { render, staticRenderFns } from "./SeminarItem.vue?vue&type=template&id=53c6dc56&scoped=true&lang=pug&"
import script from "./SeminarItem.vue?vue&type=script&lang=ts&"
export * from "./SeminarItem.vue?vue&type=script&lang=ts&"
import style0 from "./SeminarItem.vue?vue&type=style&index=0&id=53c6dc56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c6dc56",
  null
  
)

/* custom blocks */
import block0 from "./SeminarItem.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yml"
if (typeof block0 === 'function') block0(component)
import block1 from "./SeminarItem.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadImage: require('/app/src/components/atoms/LoadImage.vue').default})
